module.exports = {
    "dismiss": `\u{53D6}\u{6D88}`
};


//# sourceMappingURL=zh-CN.main.js.map
